import { styled } from '@linaria/react';

export const EditActions = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e0e0e0;
    justify-content: flex-end;
`;

export const SaveButton = styled.button`
    padding: 0.5rem;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
    height: 2rem;
    width: 5rem;
    &:hover:not(:disabled) {
        background-color: #45a049;
    }

    &:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
`;

export const CancelButton = styled.button`
    padding: 0.5rem;
    background-color: #f44336;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    height: 2rem;
    width: 5rem;
    transition: background-color 0.2s;

    &:hover {
        background-color: #da190b;
    }
`;

export const CopyButton = styled.button`
    padding: 0.5rem 1rem;
    background-color: #2196f3;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    white-space: nowrap;

    &:hover:not(:disabled) {
        background-color: #1976d2;
    }

    &:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
`;

export const EditableInput = styled.input`
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.875rem;
    font-family: inherit;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

export const EditableTextarea = styled.textarea`
    width: 100%;
    min-height: 100px;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.875rem;
    font-family: inherit;
    resize: vertical;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

export const EditableSelect = styled.select`
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.875rem;
    font-family: inherit;
    background-color: white;
    cursor: pointer;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

export const ErrorMessage = styled.div`
    color: #d32f2f;
    margin-top: 1rem;
    padding: 0.5rem;
    background-color: #ffebee;
    border-radius: 4px;
    font-size: 0.875rem;
`;

export const RangeInputWrapper = styled.div`
    display: flex;
    gap: 0.15rem;
    align-items: center;
`;

export const CompactInput = styled.input`
    padding: 0.15rem 0.25rem;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 0.75rem;
    font-family: inherit;
    transition: border-color 0.2s;
    text-align: right;

    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 1px rgba(33, 150, 243, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

export const CompactRangeInput = styled.input`
    padding: 0.12rem 0.2rem;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 0.7rem;
    font-family: inherit;
    transition: border-color 0.2s;
    text-align: right;

    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 1px rgba(33, 150, 243, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

// Width variants for CompactInput
export const CompactInput35 = styled(CompactInput)`
    width: 35px;
`;

export const CompactInput55 = styled(CompactInput)`
    width: 55px;
`;

export const CompactInput60 = styled(CompactInput)`
    width: 60px;
`;

export const CompactInput70 = styled(CompactInput)`
    width: 70px;
`;

export const CompactInput100 = styled(CompactInput)`
    width: 100px;
`;

export const CompactSelect = styled.select`
    padding: 0.15rem 0.25rem;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 0.75rem;
    font-family: inherit;
    background-color: white;
    cursor: pointer;
    transition: border-color 0.2s;
    max-width: 170px;
    min-width: 0;
    flex: 1;
    text-overflow: ellipsis;

    &:focus {
        outline: none;
        border-color: #2196f3;
        box-shadow: 0 0 0 1px rgba(33, 150, 243, 0.1);
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

// Width variants for CompactRangeInput
export const CompactRangeInput40 = styled(CompactRangeInput)`
    width: 40px;
`;

export const CompactRangeInput45 = styled(CompactRangeInput)`
    width: 45px;
`;

// Fixed-width unit labels for alignment
export const UnitLabel35 = styled.span`
    display: inline-block;
    width: 35px;
`;

// Fixed-width unit labels for alignment (wider for viscosity units)
export const UnitLabel45 = styled.span`
    display: inline-block;
    width: 35px;
`;
